import PropTypes from "prop-types";
import React from "react";
import Button from "react-bootstrap/Button";
import Card from "react-bootstrap/Card";

const AnnouncementSingle = ({ data }) => {
  return (
    <Card className="sticky-note">
      <Card.Body>
        <div className="row">
          <div className="col-6 col-md-6 col-sm-6 col-xs-12">
            <img src={data.img} alt={data.title} />
          </div>
          <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12 sticky-text">
            <Card.Title className="title">{data.title}</Card.Title>
            <p>{data.description}</p>
            {data.start_date && (data.start_date !== "" || data.start_date !== null) &&(
              <p>
                <b>Date:</b> {data.start_date}{data.end_date ? ` - ${data.end_date}` : ""}
              </p>
            )}    
            {data.start_time && (
              <p>
                <b>Time:</b> {data.start_time}{data.end_time ? ` - ${data.end_time}` : ""}
              </p>
            )}
            {data.button_text && data.link && (
              <Button variant={`${data.category == "past" ? "outline-secondary" : "secondary"}`} href={data.link}>
                {data.button_text}
              </Button>
            )}
          </div>
        </div>
      </Card.Body>
    </Card>
  );
};

AnnouncementSingle.propTypes = {
  data: PropTypes.object,
  sliderClassName: PropTypes.string,
  spaceBottomClass: PropTypes.string,
};

export default AnnouncementSingle;
